var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProducers(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60.001,
    height: 60,
    viewBox: "0 0 60.001 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#2450ff;}.b{fill:#069de5;}.c{fill:#6dcef8;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-240 -1510)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-7598-1551h0a14.9,14.9,0,0,1-10.607-4.392A14.9,14.9,0,0,1-7613-1566a14.9,14.9,0,0,1,4.394-10.606A14.905,14.905,0,0,1-7598-1581v8a7.009,7.009,0,0,0-7,7,7.009,7.009,0,0,0,7,7v8Z",
    transform: "translate(7898 3091)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 15,
    cy: 15,
    r: 15,
    transform: "translate(240 1540)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 7,
    cy: 7,
    r: 7,
    transform: "translate(248 1548)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 25,
    height: 8,
    transform: "translate(275 1552)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 40,
    height: 8,
    transform: "translate(240 1521)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProducers);
export default __webpack_public_path__ + "static/media/producers.618576c35927324f0362560d6c268dc9.svg";
export { ForwardRef as ReactComponent };